export default "__VITE_ASSET__LK1feIQu__"